export default {
  "/car-life-circle/config-param/download_config-compare":
    "配置参数-配置对比下载",
  "/car-life-circle/config-param/download_param-compare":
    "配置参数-参数对比下载",
  "/car-life-circle/product-line/download": "产品线变化下载",
  "/car-life-circle/pva-vary/download": "PVA变化下载",
  "/carLoanCompare/download-loan-compare-info": "金融对比下载",
  "/car_newEnergy/capacityPlanning/export": "下载-产能",
  "/car_newEnergy/newCarListSpectrum/exportImage": "下载-新车上市计划",
  "/car_newEnergy/newEnergy/equipmentRateQuery/exportTableData":
    "下载-装配率查询",
  "/car_newEnergy/newEnergy/pointCityPrice/exportChart":
    "下载-重点城市价格-图表",
  "/car_newEnergy/newEnergy/pointCityPrice/exportTable": "下载-重点城市价格",
  "/car_newEnergy/newEnergy/policyBusiness/exportExcel":
    "下载-终端支持查询列表",
  "/car_newEnergy/newEnergy/policyBusiness/exportFile": "下载-终端支持查询文件",
  "/car_newEnergy/newEnergy/priceSales/exportBottomTableData":
    "下载-价格段分析",
  "/car_newEnergy/newEnergy/priceSales/exportEchartData": "下载-价格段分析图表",
  "/car_newEnergy/newEnergy/priceSalesRatio/ProductInfo":
    "下载-销量比例查询车型信息",
  "/car_newEnergy/newEnergy/priceSalesRatio/doLoadEchartData":
    "下载-销售比例查询列表",
  "/car_newEnergy/newEnergy/priceSalesRatio/exportChart":
    "下载-销售比例查询图表",
  "/car_newEnergy/trendAnalysis/exportChartData": "下载-销量走势分析图表",
  "/car_newEnergy/trendAnalysis/exportTableData": "下载-销量走势分析列表",
  "/dealer-monitor/channel/download-channel-index-new": "下载列表",
  "/dealer-monitor/channel/download-dealer-network-new": "下载列表",
  "/dealer-monitor/equity/export": "下载列表",
  "/dealer-monitor/equity/group-export": "下载列表",
  "/chart/sales-list-xlsx": "下载列表",
  "/compcircle-analysis/download-circle-index-trend": "下载-竞争圈趋势分析",
  "/compcircle-analysis/download-comp-rela-analysis": "下载-竞争关系分析",
  "/composite-analysis/config-change/download-config-changes": "配置变化下载",
  "/composite-analysis/price-change/download-price-chart": "价格变化下载",
  "/comprehensive-analysis/download-word-of-mouth-compare": "口碑变化下载",
  "/comprehensive-analysis/sales-change-download": "销量变化下载",
  "/configIndexAnalysis/downloadManyDimension": "配置指标分析-下载（多维度）",
  "/configIndexAnalysis/downloadSingleDimension": "配置指标分析-下载（单维度）",
  "/dlfj/sd": "xjq概览页下载按钮",
  "/download-chart": "下载权限",
  "/equity/export": "股权关系下载",
  "/excition-search/download-excition-detail": "下载（导出终端激励明细信息）",
  "/excition-search/download-excition-result": "下载（导出终端激励结果信息）",
  "/export/price/comp-landscape": "导出-竞争圈竞争格局分析",
  "/export/price/discount-trend": "导出-折扣率走势对比分析",
  "/export/price/price-range-sales-distribution": "导出-价格段销量分布",
  "/export/price/price-range-sales-trend": "导出-价格段销量变化趋势",
  "/export/price/price-struct": "导出-价格构成对比",
  "/export/price/price-trend": "导出-价格走势分析",
  "/export/sales/comp-landscape": "导出-竞争圈竞争格局分析",
  "/export/sales/sales-trend": "导出-销量走势对比分析",
  "/export/sales/segment-concentration": "导出-细分市场市场集中度销量走势",
  "/export/sales/segment-potential": "导出-细分市场市场潜力销量走势",
  "/export/sales/segment-sales-trend": "导出-销量走势分析[新能源市场]",
  "/export/sales/share-trend": "导出-份额走势对比分析",
  "/export/terminal-support/comp-landscape": "导出-竞争圈竞争格局分析",
  "/export/terminal-support/month-amount-structure":
    "导出-竞争环境分析(月度激励金额结构)",
  "/export/terminal-support/submodel-incentive-trend":
    "导出-总激励走势对比分析",
  "/export/terminal-support/terminal-support-incentive-trend":
    "导出-终端支持总激励走势分析",
  "/export/terminal-support/year-amount-structure":
    "导出-竞争环境分析(年度激励金额结构)",
  "/exportConfigQueryProvider/exportConfigDict": "配置字典-下载",
  "/exportConfigQueryProvider/exportModelConfigCompare":
    "车型配置对比-下载（导出配置查询）",
  "/exportConfigQueryProvider/exportModelConfigCompareDetail":
    "车型配置对比明细-下载",
  "/exportConfigQueryProvider/exportModelConfigLevel":
    "车型配置梯度-下载（导出配置）",
  "/exportConfigQueryProvider/exportModelConfigQuery":
    "车型配置明细-下载（导出配置查询）",
  "/exportConfigQueryProvider/exportModelConfigQueryDetail":
    "车型配置查询明细-下载",
  "/exportConfigQueryProvider/exportModelConfigSwotCompare":
    "车型配置对比-1V1-下载（ 导出配置）",
  "/exportSingleModelTerminal/exportAllExcitationAnalyze":
    "下载（ 导出总激励走势分析）",
  "/exportSingleModelTerminal/exportCompetitionSituation": "竞争格局分析-下载",
  "/exportSingleModelTerminal/exportModelPriceTrend":
    "下载（导出单车价格策略分析数据）",
  "/exportSingleModelTerminal/exportMonthExcitationAnalyze":
    "下载（导出月度激励走势）",
  "/exportSingleModelTerminal/exportMonthStimulateCondition":
    "下载（  导出月度激励节奏）",
  "/exportSingleModelTerminal/exportMthStimulateStructureComparison":
    "下载（导出月度激励结构对比）",
  "/exportSingleModelTerminal/exportProfitAnalyze":
    "下载（ 导出利润走势分析数据）",
  "/exportSingleModelTerminal/exportProfitSaleDistribute": "销量分布-下载",
  "/exportSingleModelTerminal/exportProfitStructure":
    "下载（导出利润结构对比数据）",
  "/exportSingleModelTerminal/exportTotalStimulateStructureComparison":
    "下载（导出总激励结构对比）",
  "/exportSingleModelTerminal/exportYearStimulateComparison":
    "下载（ 导出年度激励对比）",
  "/exportSingleModelTerminal/exportYearStimulateStructureComparison":
    "下载（导出年度激励结构对比）",
  "/exportTargetAnalysisProvider/exportDiffContrastTable":
    "车型配置供需-下载（差异对比）",
  "/exportTargetAnalysisProvider/exportListDetailTable":
    "车型配置供需-下载（列表清单）",
  "/finance-search/finance-productinfo-xlsx": "金融查询下载",
  "/finance-search/spc-xlsx": "下载至具体方案",
  "/forecast-report/download-report": "下载",
  "/incent/dowloadMIX": "MIX数据导出",
  "/incent/downloadFile": "终端激励导出",
  "/index/listing-forecast-xlsx": "导出-新车上市预测",
  "/index/listing-statistics-xlsx": "导出-新车上市统计",
  "/installEquip/downloadEquipRateEchartsLine": "装车率装备率-下载（装备率）",
  "/installEquip/downloadEquipVersion": "装备型号反查-下载",
  "/lifecircle-overview/download-lists": "生命周期概览下载",
  "/manfbrand-analysis/comp-sales-trend-download": "下载-厂商品牌竞品市场",
  "/manfbrand-analysis/market-analysis-download": "下载-厂商品牌整体-分析诊断1",
  "/manfbrand-analysis/region-analysis-download":
    "下载-厂商品牌分区域-分析诊断",
  "/manfbrand-analysis/submodel-analysis-download":
    "下载-厂商品牌分车型-分析诊断",
  "/manfbrand-analysis/total-sales-trend-download":
    "下载-厂商品牌整体-销量趋势分析",
  "/market-overview-export/city-level-analysis": "下载-城市层级市场分析",
  "/market-overview-export/manf-rank": "下载-厂商排行榜",
  "/market-overview-export/market-analysis": "下载-整体市场分析",
  "/market-overview-export/nati-analysis": "下载-系别市场分析",
  "/market-overview-export/origin-analysis": "下载-品牌属性分析",
  "/market-overview-export/region-rank": "下载-区域排行榜",
  "/market-overview-export/segment-analysis": "下载-细分市场分析",
  "/market-overview-export/submodel-rank": "下载-车型排行榜",
  "/mock/market-overview/xlsx": "概览下载",
  "/model-overview/model-financeinfo-xlsx": "导出-子车型金融信息",
  "/multiCross/exportMultiCross": "参数交叉分析-下载",
  "/policy-query/policy-download": "列表-下载",
  "/policy/buildFile": "公共报告，政策首页详情，浏览全部、下载",
  "/policy/buildFile/*": "政策详情 打开、下载",
  "/policy/buildFile2": "政策搜索，专题报告 浏览全部、下载",
  "/policy/exportCatalogDetial": "新能源行业目录下载",
  "/policy/exportSubsidyDetail": "补贴政策概览下载",
  "/policy/exportSubsidyModelDetialOfCity": "新能源补贴车型详情下载",
  "/policy/exportSubsidyOfModel": "新能源补贴车型列表下载",
  "/public-report/buildFile/big-data": "浏览&下载",
  "/public-report/buildFile/car-loan": "浏览&下载",
  "/public-report/buildFile/enterprise": "浏览&下载",
  "/public-report/buildFile/news": "下载",
  "/public-report/buildFile/sales-overview": "浏览&下载",
  "/pvaCompareAnalysis/downloadModelVersionInfo": "车型PVA对比-下载",
  "/pvaCompareAnalysis/downloadSubModel": "车型对比分析-下载",
  "/pvaCompareAnalysis/downloadVersionPvaComapreDetail":
    "车型PVA对比-详情-下载",
  "/regionMarket/city-level-sales-trend-download": "导出-城市表现-销量结构走势",
  "/regionMarket/different-city-model-info-download":
    "导出-不同城市级别偏好-车型信息",
  "/regionMarket/different-city-model-rank-download":
    "导出-不同级别城市偏好-车型排名列表",
  "/regionMarket/limit-city-market-property-download":
    "导出-限购非限购-市场表现-分产权",
  "/regionMarket/limit-city-market-state-download":
    "导出-限购非限购-市场表现-分产地",
  "/regionMarket/limit-city-market-tb-download":
    "导出-限购非限购-市场表现-销量同比",
  "/regionMarket/limit-city-market-trend-download":
    "导出-限购非限购-市场表现-销量走势",
  "/regionMarket/limit-city-model-info-download": "导出-限购非限购-车型信息",
  "/regionMarket/limit-city-model-rank-download":
    "导出-限购非限购-车型排名列表",
  "/regionMarket/limit-city-sales-trend-download":
    "导出-限购非限购-销量结构走势",
  "/regionMarket/market-sales-property-download": "导出-市场表现-分产权",
  "/regionMarket/market-sales-state-download": "导出-市场表现-分产地",
  "/regionMarket/market-sales-tb-download": "导出-市场表现-销量同比",
  "/regionMarket/market-sales-trend-download": "导出-市场表现-销量走势",
  "/regionMarket/new-eng-sales-ranking-download": "导出-新能源销量排行榜",
  "/regionMarket/state-submodel-sales-ranking-download":
    "导出-地区车型销量排行榜",
  "/business-circle/report/bc-analysis-page-download": "城市分析下载",
  "/business-circle/report/bp-dealer-page-download": "本品经营数据下载",
  "/business-circle/report/dealer-xlsx": "商圈分析下载",
  "/business-circle/report/simulate-dealer-xlsx": "模拟建店数据分析下载",
  "/reward-class-detail/download-reward-class-detail": "下载（导出奖励项明细）",
  "/reward-compare/download-reward-compare": "下载（导出奖励项对比列表）",
  "/reward-tool/download": "返利工具下载",
  "/reward/downloadItemData": "奖励项对比导出",
  "/reward/downloadTypeData": "奖励分类明细导出",
  "/sales-simulate-tool/plan/download-plan-detail": "下载方案",
  "/salse-forecast/download-manf-forecast": "下载",
  "/salse-forecast/download-region-forecast": "下载区域/省份/城市",
  "/salse-forecast/download-submodel-forecast": "下载",
  "/satis-analysis/download-advan-disadvan-item": "下载-优劣势分析",
  "/satis-analysis/download-attention-satis-diagram": "下载-细项关注度&满意度",
  "/satis-analysis/download-comp-model-satis-bar": "下载-满意度分析对比竞品",
  "/satis-analysis/download-idx-satis-radar": "下载-满意度分析满意度",
  "/segment/download-history-trend": "导出-历史走势",
  "/segment/download-segment-view": "导出-细分市场概览",
  "/segmentMarket/eng-segment-market-share-download": "细分市场-各系别份额",
  "/segmentMarket/eng-segment-market-trend-download":
    "导出-细分市场集中度-各系别销量走势",
  "/segmentMarket/eng-segment-sales-property-download":
    "导出-细分市场表现-分产权",
  "/segmentMarket/eng-segment-sales-rank-download": "导出-车型销量排行榜",
  "/segmentMarket/eng-segment-sales-state-download": "导出-细分市场表现-分产地",
  "/segmentMarket/eng-segment-sales-struts-download": "导出-市场销量结构",
  "/segmentMarket/eng-segment-sales-tb-download": "导出-细分市场表现-销量同比",
  "/segmentMarket/eng-segment-sales-trend-download":
    "导出-细分市场表现-销量走势",
  "/segmentMarket/segment-sales-compare-download":
    "导出-整体市场VS新能源市场-销量结构",
  "/singleModelTerminalProvider/getMonthExcitationAnalyze":
    "下载（获取月度激励分析数据）",
  "/singleModelTerminalProvider/getProfitSaleDistribute":
    "下载（ 获取利润-销量分布数据）",
  "/singleModelTerminalProvider/getProfitStructure":
    "下载（ 获取利润结构对比数据）",
  "/singleModelTerminalProvider/getTableData": "下载（ 获取终端分析数据）",
  "/singleModelTerminalProvider/getTotalSaleData": "下载（获取销量数据）",
  "/submodel-analysis/comp-market-analysis-download": "下载-车型竞品市场",
  "/submodel-analysis/download-submodel-rank": "下载-竞争圈排行榜",
  "/submodel-analysis/over-analysis-download": "下载-车型整体-分析诊断",
  "/submodel-analysis/region-analysis-download": "下载-车型区域-分析诊断",
  "/submodel-analysis/sales-trend-analysis-download": "下载-车型销量趋势-分析",
  "/submodel-overview/download-get-submodel-overview": "下载-车型概览|关注车型",
  "/submodel-overview/download-submodel-rank": "下载-车型排行榜",
  "/terminalStimulate/downPattern": "格局表现导出",
  "/terminalStimulate/downStrategy": "单车型价格策略导出",
  "/terminalStimulate/exportAllExcitationAnalyze": "总激励导出",
  "/terminalStimulate/exportMonthExcitation": "月度激励导出",
  "/terminalStimulate/exportProfitAnalyze": "利润分析导出",
  "/terminalStimulate/exportTerminalAnalyzeTableData": "厂商品牌表格下载",
  "/terminalStimulate/exportYearExcitationAnalyze": "年度激励导出",
  "/totalMarket/car-fuel-type-sales-download":
    "导出-分产地属性销量增速表现-分燃料",
  "/totalMarket/car-type-sales-trend-download":
    "导出-分产地属性销量及增速表现-产地",
  "/totalMarket/eng-market-chart-download": "导出-新能源乘用车市场概况",
  "/totalMarket/eng-type-sales-chart-download":
    "导出-分燃料类型销量及增速表现-电动类型",
  "/totalMarket/fuel-type-sales-chart-download":
    "导出-分燃料类型销量增速表现-销量占比",
  "/totalMarket/property-sales-trend-download":
    "导出-分产权属性销量及增速表现-产权类型",
  "/totalMarket/property-type-sales-download":
    "导出-分产权属性销量增速表现-燃料类型",
  "/vehicle-configuration/pvaCompareAnalysis/downloadModelVersionInfo":
    "型号对比分析-获取连线图-下载",
  "/volume-analysis/download-comp-rela-diagram": "下载-竞争圈声量分析",
  "/volume-analysis/download-get-volume-overview": "下载-声量概览",
  "/volume-analysis/download-region-volume-sales": "下载-分区域声量&销量概况",
  "/volume-analysis/download-volume-trends": "下载-竞争圈声量&销量趋势图",
  "/selfMadeUpload/downSelfMadeModelTemplate": "下载-自造车模板",
  // 组合查询
  "/iw-sales/senior-export/splitExport": "下载-拆分条件查询",
  "/iw-sales/senior-export/combineExport": "下载-组合条件查询",
  "/iw-sales/senior-export/detailExport": "下载-明细列表",
  // 销量比例
  "/iw-sales/overall/exportChart": "下载-整体市场-价格段销量分析图",
  "/iw-sales/overall/exportTable": "下载-整体市场-价格段销量列表",
  "/iw-sales/subdivide/exportChart": "下载-细分市场-价格段销量分析图",
  "/iw-sales/subdivide/exportTable": "下载-细分市场-价格段销量列表",
  "/iw-sales/manufacturer/exportChart": "下载-厂商市场-价格段销量分析图",
  "/iw-sales/manufacturer/exportTable": "下载-厂商市场-价格段销量列表",
  "/iw-sales/model/exportPriceRangeChart": "下载-车型市场-价格梯度",
  "/iw-sales/model/exportChart": "下载-车型市场-价格段销量分析图",
  "/iw-sales/model/exportTable": "下载-车型市场-价格段销量列表",
  "/iw-sales/salesRatio/exportPriceSegmentChart":
    "下载-销量比例分析-价格段销量分析图",
  "/iw-sales/salesRatio/exportPriceSegmentTable":
    "下载-销量比例分析-价格段销量列表",
  "/iw-sales/salesRatio/exportModlCompareChart":
    "下载-销量比例分析-车型对比分析图",
  "/iw-sales/salesRatio/exportModlCompareTable":
    "下载-销量比例分析-车型对比分析列表",
  "/iw-sales/salesRatio/exportRatioQuery": "下载-销量比例查询",
  // 销量分析
  "/v3/iw-sales/pv/export-sales-trend": "下载-整体市场-销量分析图",
  "/v3/iw-sales/pv/export-table-sales":
    "下载-整体市场|厂商市场|细分市场-销量列表",
  "/v3/iw-sales/pv/export-subd-trend": "下载-细分市场-销量分析图",
  "/v3/iw-sales/sale/areaMarket/exportChartData": "下载-区域市场-销量分析图",
  "/v3/iw-sales/sale/areaMarket/exportAreaTableAreaData":
    "下载-区域市场-销量列表-区域",
  "/v3/iw-sales/sale/areaMarket/exportAreaTableBrandData":
    "下载-区域市场-销量列表-品牌",
  "/v3/iw-sales/sale/areaMarket/exportAreaTableManfData":
    "下载-区域市场-销量列表-厂商",
  "/v3/iw-sales/sale/areaMarket/exportAreaTableManfBrandData":
    "下载-区域市场-销量列表-厂商品牌",
  "/v3/iw-sales/sale/areaMarket/exportAreaTableModelData":
    "下载-区域市场-销量列表-车型",
  "/v3/iw-sales/sale/areaMarket/exportAreaTableSubdData":
    "下载-区域市场-销量列表-细分市场",
  "/v3/iw-sales/manf/export-manf-rank": "下载-厂商市场-销量分析图-排名走势",
  "/v3/iw-sales/manf/export-manf-list": "下载-厂商市场-销量分析图-排名列表",
  "/v3/iw-sales/manf/export-manf-trend": "下载-厂商市场-销量分析图-趋势",
  "/v3/iw-sales/manf/export-manf-table": "下载-厂商市场-销量列表-车型表现",
  "/v3/iw-sales/sales/modelMarket/exportChartData": "下载-车型市场-销量分析图",
  "/v3/iw-sales/sales/modelMarket/exportModelView":
    "下载-车型市场-销量列表-二级细分市场",
  "/v3/iw-sales/sales/modelMarket/exportModelViewFirstSegment":
    "下载-车型市场-销量列表-一级细分市场",
  "/v3/iw-sales/sales/modelMarket/exportAreaViewGridDataBySingle":
    "下载-车型市场-销量列表-区域",
  // 价格分析
  "/iw-price/overall/exporTrend": "下载-整体市场-整体市场价格指数",
  "/iw-price/overall/exporSegment": "下载-整体市场-细分市场",
  "/iw-price/overall/exporOverallMarketSubmodel": "下载-整体市场-细分市场",
  "/iw-price/subModel/exportTrendForSubModel": "下载-车型市场-价格走势",
  "/iw-price/subModel/exportForCity": "下载-车型市场-各城市价格情况",
  "/iw-price/subModel/exportForArea": "下载-车型市场-区域表现",
  "/iw-price/query/exporPriceQuery": "下载-价格查询",
  "/iw-price/query/exporPriceQueryExternal": "下载-价格查询-原始数据",
  "/iw-price/discount/exportRankList": "下载-车型折扣排名-车型折扣排名",
  "/iw-price/discount/exportTrendList": "下载-车型折扣排名-车型价格走势",
  "/iw-price/brndMarkActv/exportList": "下载-品牌营销活动-活动列表",
  "/iw-price/priceSales/exporQuadrant": "下载-价量分析-价量象限图",
  "/iw-price/priceSales/exporTrend": "下载-价量分析-价格走势图"
};
